import { defineComponent as i, useSlots as g, openBlock as r, createBlock as c, unref as t, mergeProps as f, withCtx as m, createElementVNode as n, normalizeClass as u, createElementBlock as s, renderSlot as a, createCommentVNode as d } from "vue";
import "./ghl-ui.es371.js";
import h from "./ghl-ui.es372.js";
const y = {
  key: 0,
  class: "flex items-center h-full"
}, p = { style: { width: "100%" } }, b = i({
  name: "UITag",
  inheritAttrs: !1
}), $ = i({
  ...b,
  props: {
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "medium"
    },
    round: {
      type: Boolean,
      default: !0
    },
    bordered: {
      type: Boolean,
      default: !0
    },
    groupPosition: {
      type: String,
      default: "left"
    }
  },
  setup(e) {
    const l = g();
    return (o, B) => (r(), c(t(h), f({
      class: [
        `hl-${e.type}`,
        e.bordered ? null : "hl-border-hidden",
        t(l).group ? `hl-tag-padding-${e.groupPosition}` : ""
      ]
    }, o.$attrs, {
      type: e.type,
      closable: e.closable,
      size: e.size,
      round: e.round
    }), {
      default: m(() => [
        n("div", {
          class: u([
            "flex items-center space-x-1 h-full",
            t(l).group ? `hl-tag-group__${e.groupPosition}` : null
          ])
        }, [
          t(l).icon ? (r(), s("div", y, [
            a(o.$slots, "icon")
          ])) : d("", !0),
          t(l).group ? (r(), s("div", {
            key: 1,
            class: u([
              "hl-tag-group",
              `hl-tag-group__${e.type}`,
              e.bordered ? null : "hl-border-hidden",
              e.groupPosition === "left" ? "mr-1" : "ml-2",
              `hl-tag-group__${e.groupPosition}`,
              e.round ? "hl-tag-group__border-radius" : ""
            ])
          }, [
            a(o.$slots, "group")
          ], 2)) : d("", !0),
          n("div", p, [
            a(o.$slots, "default")
          ])
        ], 2)
      ]),
      _: 3
    }, 16, ["class", "type", "closable", "size", "round"]));
  }
}), S = $;
export {
  S as default
};
